// extracted by mini-css-extract-plugin
module.exports = {"helpFrame":"_4hIxBO2","body":"_1iFFKkb"};